import { Box, IconButton, Typography } from "@outschool/backpack";
import { faTimes } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import { Modal } from "@outschool/ui-legacy-component-library";
import React from "react";

import PublicReviewsOfLeaderInfiniteScroll from "./PublicReviewsOfLeaderInfiniteScroll";
import StarRatings from "./StarRatings";

type PublicReviewsOfLeaderModalProps = {
  leaderUid: string;
  isReviewModalOpen: boolean;
  setIsReviewModalOpen: (val: boolean) => void;
  averageActivityStarRating: number;
  reviewCount: number;
  ReviewRespondButton?: React.ElementType;
};

const PublicReviewsOfLeaderModal: React.FunctionComponent<
  PublicReviewsOfLeaderModalProps
> = ({
  leaderUid,
  isReviewModalOpen,
  setIsReviewModalOpen,
  averageActivityStarRating,
  reviewCount,
  ReviewRespondButton,
}) => {
  return (
    <Modal
      open={isReviewModalOpen}
      onClose={() => setIsReviewModalOpen(false)}
      sx={{
        height: "90vh",
        position: "relative",
        padding: "0px",
      }}
      hasCloseButton={false}
    >
      <Box
        sx={{
          height: "100%",
          paddingX: "24px",
          paddingBottom: "0px",
          overflowY: "auto",
          paddingTop: "105px",
        }}
      >
        <PublicReviewsOfLeaderModalHeader
          setIsReviewModalOpen={setIsReviewModalOpen}
          averageActivityStarRating={averageActivityStarRating}
          reviewCount={reviewCount}
        />
        <PublicReviewsOfLeaderInfiniteScroll
          leaderUid={leaderUid}
          ReviewRespondButton={ReviewRespondButton}
        />
      </Box>
    </Modal>
  );
};

type PublicReviewsOfLeaderModalHeaderProps = {
  setIsReviewModalOpen: PublicReviewsOfLeaderModalProps["setIsReviewModalOpen"];
  averageActivityStarRating: PublicReviewsOfLeaderModalProps["averageActivityStarRating"];
  reviewCount: PublicReviewsOfLeaderModalProps["reviewCount"];
};

const PublicReviewsOfLeaderModalHeader: React.FunctionComponent<
  PublicReviewsOfLeaderModalHeaderProps
> = ({ setIsReviewModalOpen, averageActivityStarRating, reviewCount }) => {
  const { t } = useTranslation(
    "ui-components-website\\src\\Reviews\\PublicReviewsOfLeaderModal",
  );
  return (
    <Box
      sx={{
        background: "white",
        paddingBottom: "20px",
        borderRadius: "0.5em",
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        paddingX: "24px",
        paddingTop: "24px",
        zIndex: 2001,
      }}
    >
      <Typography variant="h3">{t("Reviews")}</Typography>
      <Box
        sx={{
          marginTop: "8px",
        }}
      >
        <StarRatings
          rating={averageActivityStarRating}
          sx={{ marginRight: "0.5em" }}
        />
        {t("{{reviewCount}} total review", {
          reviewCount,
          count: reviewCount,
          defaultValue_plural: "{{reviewCount}} total reviews",
        })}
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: "0.5em",
          right: "0.5em",
          zIndex: 1,
        }}
      >
        <IconButton
          icon={faTimes}
          iconProps={{ sx: { fontSize: "1.333em" } }}
          onClick={() => setIsReviewModalOpen(false)}
          aria-label={t("Close")}
        />
      </Box>
    </Box>
  );
};
export default PublicReviewsOfLeaderModal;
